export default defineNuxtPlugin(() => {
  syncLastViewedDocumentItemFromRoute();
});